import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullNameShorter'
})
export class FullNameShorterPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    const nameArray = value.split(' ');
    const firstLetter = nameArray[0].slice(0, 1);
    const secondLetter = nameArray[1].slice(0, 1);
    return firstLetter + secondLetter;
  }

}
